<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-flow-modal-list">
      <h2>Preenchimento Notificação de Agravo</h2>
    </div>

    <div class="body-flow-modal-list">
      @if (isMandatoryComletion) {
        <span>
          O preenchimento desta Notificação de Agravo foi definido como obrigatório após
          a finalização da Classificação de Risco. Por favor, clique no botão abaixo para ir à tela de
          preenchimento.
        </span>
      }
      @if (!isMandatoryComletion) {
        <span>
          Você deseja preencher a Notificação de Agravo deste paciente ao finalizar este atendimento? Se optar por
          preencher depois, o formulário estará disponível para ser concluído no menu "Gerenciamento de Notificações",
          do módulo Classificação de Risco.
        </span>
      }
    </div>
    <div class="footer-flow-modal-list">
      <button mat-flat-button color="primary" class="btn-block" (click)="clickConfirm()">
        @if (isMandatoryComletion) {
          <span>Preencher notificação</span>
        }
        @if (!isMandatoryComletion) {
          <span>Sim, preencher</span>
        }
      </button>
      @if (!isMandatoryComletion) {
        <button mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">
          <span>Preencher depois</span>
        </button>
      }
    </div>
  </div>
</div>